const toPositiveInt = (value, fallback) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return fallback;
  const i = Math.floor(n);
  return i > 0 ? i : fallback;
};

const config = {
  apiUrl: 'https://starcopy.online/api',
  // Controls the delay between completed Affiliate refresh cycles.
  // Override in CRA builds with `REACT_APP_AFFILIATE_REFRESH_MS`.
  affiliateRefreshMs: toPositiveInt(process.env.REACT_APP_AFFILIATE_REFRESH_MS, 5000)
};

export default config;
